export default {
  path: '/manutencao',
  component: () => import('@/components/pages/MaintenancePage'),
  name: 'maintenance'
}
